import { EventEmitter } from 'eventemitter3';
export var events = new EventEmitter();
